/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/SpiderLogic/ChallengeAuthorities/SolveGameDailySpiderAuthority',[
    'SolitaireShared/SpiderLogic/IDailySpiderAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority'

], function (IDailySpiderAuthority, IDailyAuthority) {
    "use strict";

    var SolveGameDailySpiderAuthority = function (param) {
        this.initSolveGameDailySpiderAuthority(param);
    };

    SolveGameDailySpiderAuthority.constructor = SolveGameDailySpiderAuthority;
    SolveGameDailySpiderAuthority.prototype = Object.create(IDailySpiderAuthority.prototype);

    SolveGameDailySpiderAuthority.prototype.initSolveGameDailySpiderAuthority = function (param) {
        IDailySpiderAuthority.call(this, param);

        this.ChallengeType = IDailyAuthority.ChallengeType.SolveGame;
    };

    return SolveGameDailySpiderAuthority;


});
